export const COLORS = {
  darkBlack: '#1A191E',
  black: '#10182F',
  grey: '#5A6475',
  error: '#E8616B',
  green: '#5CB5A2'
};
